<template>
  <CancerView icd="C34" icd-presentation-string="C34"
              icd-description="Malignant neoplasm of bronchus and lung"
              disease-description="lung cancer"
              :mesh-ids="['D008175']"
              mesh-description="Lung Neoplasms">
  </CancerView>
</template>

<script>
import CancerView from '@/components/CancerView.vue';
import {defineComponent} from "vue";

export default defineComponent({
  name: 'lung-cancer-page',
  components: {
    CancerView
  }
});
</script>
